"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterListItem = exports.SelectionType = void 0;
var SelectionType;
(function (SelectionType) {
    SelectionType["SINGLE"] = "single_select";
    SelectionType["MULTIPLE"] = "multi_select";
})(SelectionType || (exports.SelectionType = SelectionType = {}));
class FilterListItem extends Array {
    constructor(type, order, header, name, value, selectionType = SelectionType.MULTIPLE, filters) {
        super();
        this.getOrdered = () => this.sort((x, y) => (x.order > y.order ? 1 : -1));
        this.order = order;
        this.header = header;
        this.name = name;
        this.value = value;
        this.type = type;
        this.selectionType = selectionType;
        if (filters !== null && filters !== undefined) {
            filters.forEach(filter => this.push(filter));
        }
    }
}
exports.FilterListItem = FilterListItem;
FilterListItem.fromArray = (type, order, header, name, value, selectionType, filters) => new FilterListItem(type, order, header, name, value, selectionType, filters);
//# sourceMappingURL=FilterListItem.js.map